import React from 'react';
import './Sections.scss';

function Section5() {
  return (
    <section className="sections sections-section5">
      <h2 className="sections-title">Spend on prevention to avoid busting budget on cures</h2>
      <p className="sections-copy">
        As the old saying goes, “An ounce of prevention is worth a pound of cure.” When it comes to
        protecting the value of a home, don’t neglect basic maintenance tasks until a
        catastrophic—and expensive—failure occurs.
      </p>
      <p className="sections-copy">
        The best approach is to regularly monitor the health of the home’s major infrastructure
        components including HVAC (heating, ventilation, and air conditioning) systems, water
        heaters, roofs, siding, and foundations. If any issues do arise, try to fix them right away
        instead of brushing them under the rug.
      </p>
      <p className="sections-copy">
        Home maintenance and repairs can be expensive, so keep those costs in mind when shopping for
        a home. Buyers who put all of their savings into a down payment risk falling behind on their
        mortgage in the event of a job loss, expensive home repair, or major hospital bill. Remember
        that missing a couple of mortgage payments not only damages your credit score, but could
        even lead to your lender starting foreclosure proceedings and trying to force the sale of
        your home.
      </p>
      <p className="sections-copy">
        Yun emphasizes that buyers should not overstretch themselves financially to buy the most
        expensive home they can possibly afford. “It’s better to spend less up front and have some
        cash on hand in a reserve fund to provide a protective buffer and some peace of mind,” he
        says.
      </p>
    </section>
  );
}

export default Section5;
